module.exports = __webpack_public_path__ + "img/mat_210.65b80c98.png";